import { IGenerateJobDescriptionResponse } from '../types';
import { PermanentJobsApi } from '../clients';

export const generateJobDescription = async (
  postingId: string,
  officeId?: string,
): Promise<IGenerateJobDescriptionResponse> =>
  PermanentJobsApi.generateJobDescription(postingId, officeId);
